const Input = ({ 
    type, 
    placeholder, 
    name = '', 
    className = '', 
    minLength = 3,
    maxLength = 100,
    onChange, 
    value,
    pattern="",
    isSubmitted // <--- New Prop
}) => {

    // Logic: 
    // 1. If NOT submitted, we don't apply any invalid styles.
    // 2. If submitted, we show error borders/text.
    // 3. BUT, we verify that 'focus:invalid' forces the color back to 'dusty-blue-light' (normal)
    //    so the user can type in peace.
    
    const validationClasses = isSubmitted 
        ? "invalid:border-error-text invalid:text-error-text focus:invalid:border-dusty-blue-light focus:invalid:text-input" 
        : "";

    return (
        <input 
            type={type} 
            value={value} 
            onChange={onChange} 
            required 
            name={name}
            maxLength={maxLength}
            minLength={minLength}
    
            placeholder={placeholder} 
            className={`
                ${className}
                ${validationClasses}
                placeholder:text-dusty-20
                placeholder:opacity-20 
                focus:border-dusty-blue-light 
                hover:border-dusty-blue-light 
                pt-[1rem] 
                outline-none 
                focus:text-dark-blue
                transition-colors 
                text-input 
                px-[0.4rem] 
                w-full 
                pb-[1.2rem] 
                border-b-[1px] 
                border-dusty-blue-light-40
            `}
        />
    );
};

export default Input;